import { datasetAPI } from 'api/dataset';
import { FindAllDatasetDto } from 'dto/dataset';
import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  filters: FindAllDatasetDto;
};

export function useFindAllDataset(props: PropsType) {
  const query = useQuery({
    queryKey: QUERY_KEY.FIND_ALL_DATASET,
    queryFn: () => datasetAPI.findAll(props.filters),
  });

  useEffect(() => {
    query.refetch();
  }, [props.filters]);

  return {
    query: query,
    count: query.data?.count ?? 0,
    rows: query.data?.rows ?? [],
    loading: query.isLoading || query.isFetching || query.isRefetching,
  };
}
